import { useContext, useEffect } from "react";
import MessageScreen from "../components/MessageScreen"; 
import { ChatContext } from "../context/ChatContext"; 

const MessagesDashboard = () => { // Add key prop if not already present from Dashboard.jsx
  const { data } = useContext(ChatContext); 
  useEffect(() => {
 
  }, [data.accountData, data.isAccountDataLoading, data._accountDataVersion]); // Depend on these to log changes
  return (
    <section
      aria-labelledby="primary-heading"
      className="sm:flex h-full min-w-0 flex-1 flex-col overflow-y-auto"
    > 
      <div className="flex flex-col h-full">
        <MessageScreen />
      </div>
    </section>
  );
};

export default MessagesDashboard;
